import { i18n } from "src/boot/i18n"
import { TableColumn } from "src/util/types/components/sfxTable"

export const TABLE_PAGING_VALUES = [10, 20, 40, 60, 80]

export const TABLE_COLUMN_IMAGE = "image"
export const TABLE_COLUMN_INDICATOR = "indicator"
export const TABLE_COLUMN_STATUS = "status"
export const TABLE_COLUMN_WORK_STATE = "workState"
export const TABLE_COLUMN_WORK_ORDER_STATE = "workOrderState"
export const TABLE_COLUMN_RIGHT_SIDE_ICON = "rightSideIcon"

export const TABLE_BODY_CELL = "body-cell"
export const TABLE_HEADER_CELL = "header-cell"
export const TABLE_SELECTION_SIZE = 56
export const TABLE_SELECTION_SIZE_PX = TABLE_SELECTION_SIZE + "px"
export const TABLE_SELECTION_ARROW_SIZE = "16px"
export const TABLE_STATUS_ICON_SIZE = 28 // 20 icon + 2 x 4 icon padding
export const TABLE_STATUS_PADDING = 20 // 2 x 10
export const TABLE_IMAGE_SIZE = 80 // Based on Figma designs
export const TABLE_BORDER_SPACING = 16 // 8 x 2
export const TABLE_RIGHT_SIDE_ICON_SLOT = "right-side-icon"
export const TABLE_WORK_STATE_COLUMN_SIZE = 120
export const TABLE_WORK_ORDER_STATE_COLUMN_SIZE = 120

export const STATUS_COLUMN: TableColumn = {
  name: TABLE_COLUMN_STATUS,
  label: "Status",
  field: TABLE_COLUMN_STATUS,
  sortable: true,
  required: true,
  switchable: false,
} as const

export const WORK_STATE_COLUMN: TableColumn = {
  name: TABLE_COLUMN_WORK_STATE,
  label: "State",
  field: TABLE_COLUMN_WORK_STATE,
  sortable: true,
  required: true,
  switchable: false,
} as const

const { t } = i18n.global
const stateTranslated = t("sfxTable.state_work_order")

export const WORK_ORDER_STATE_COLUMN: TableColumn = {
  name: TABLE_COLUMN_WORK_ORDER_STATE,
  label: stateTranslated,
  field: TABLE_COLUMN_WORK_ORDER_STATE,
  sortable: true,
  required: true,
  switchable: false,
} as const

export const RIGHT_SIDE_ICON_COLUMN: TableColumn = {
  name: TABLE_COLUMN_RIGHT_SIDE_ICON,
  label: "rightSideIcon",
  field: "rightSideIcon",
  sortable: false,
  required: false,
  switchable: false,
} as const

export const WORK_ORDER_STATE_SORT = new Map([
  ["overdue", 10],
  ["behind", 20],
  ["resource", 30],
  ["draft", 40],
  ["in_progress", 50],
  ["open", 60],
  ["complete", 70],
  ["planned", 80],
  ["complete_closed", 90],
  ["closed", 100],
  ["unknown", 110],
])
